const TokenKey = 'supplierEdc-Token'
const IdKey = 'upplierEdc-Id'

export function getToken() {
    return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
    return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
    return sessionStorage.removeItem(TokenKey)
}

export function setId(id) {
    return sessionStorage.setItem(IdKey, id)
}

export function getId(id) {
    return sessionStorage.getItem(IdKey, id)
}
